export const AUTH_CODE = {
  PASSWORD_DOES_NOT_MATCH: "Email or password is not valid.",
  USER_NOT_FOUND: "User not found.",
  WAITING_FOR_DECISION:
    "Your account is pending approval. Once approved, an email will be sent to you.",
  REJECTED: (
    <div>
      Your account has been rejected. If you have any question,{" "}
      <a href="https://support.asinzen.com " target="_blank" rel="noreferrer">
        please contact support
      </a>
      .
    </div>
  ),
  EMAIL_ALREADY_USED: (
    <div>
      This email address is already registered. If it belongs to you, sign in to
      access this account. If you forgot your password please click here to{" "}
      <a href="/forgot-password" target="_blank" rel="noreferrer">
        recover it
      </a>
      .
    </div>
  ),
  CODE_ALREADY_USED: "This code is taken. Try another.",
  EMAIL_DOES_NOT_EXIST: "Email does not exist.",
  EXCEPTION: "Exception.",
  PASSWORD_MISSING: "Password missing.",
  HAS_OCCUR: "Has occur contact administrator.",
};

export const PARTNER_TRACKING = {
  USER_ALREADY_HAS_TRACKING: "User already has tracking.",
  CODE_NOT_FOUND: "Code not found.",
  TRACKING_LINK_NOT_FOUND: "Tracking link not found.",
};

export const GENERAL_CODE = {
  ALIAS_CREATED: "Alias already created.",
  PARTNER_NOT_FOUND: "Partner not found.",
  TRACKING_LINK_NOT_FOUND: "Tracking link not found.",
  INVALID_DATE_TIME: "Invalid date time",
  ...AUTH_CODE,
  ...PARTNER_TRACKING,
};
